<template>
<v-dialog v-model="DisplayDialog" transition="dialog-bottom-transition" max-width="400px" persistent @keydown.esc="Confirmed()" @keydown.enter="Confirmed()">
    <v-card>
        <v-card-title class="headline">
            <v-icon class="mr-2" large :color="DialogColour">{{DialogIcon}}</v-icon>
            {{DialogTitle}}
        </v-card-title>
        <v-card-text>
            {{DialogContents}}
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="DialogColour != 'success' ? 'info' : DialogColour" @click="Confirmed()">OK</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    props: {
        DisplayDialog: {
            type: Boolean,
            required: true
        },
        DialogTitle: {
            type: String,
            required: false
        },
        DialogContents: {
            type: String,
            required: true
        },
        DialogIcon: {
            type: String, 
            required: false
        },
        DialogColour: {
            type: String, 
            required: false,
            default: "success"
        }
    },
    methods: {
        Confirmed() {
            this.$emit("ClickedOK");
        }
    }
}
</script>
